import * as ex from "excalibur";
import { Resources } from "../Resources";
import { Player } from "../player";
import { Grandpa } from "../actors/characters/grandpa";

import { goToScene } from "../main";
import FarmerJackson from "../actors/characters/farmerJackson";

export class Bills extends ex.Scene {
  constructor() {
    super();
    const player = new Player(2 * 16, 9 * 16);
    // this.backgroundColor = ex.Color.fromHex("#010101");
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 3;
  }
  onInitialize(engine) {
    Resources.JacksonsMap.addToScene(this);

    this.player.lastDir = "right";
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);

    this.player.wearingVeil = false;
    // this.player = Resources.HouseMap.getObjectsByName("player");
    this.camera.zoom = 1;

    // this.camera.strategy.lockToActor(this.player);
    this.door = new ex.Trigger({
      pos: new ex.Vector(0 * 16, 8 * 16),
      width: 16,
      height: 60,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        console.log("TRIGGERED: Go TO SCENE");
        goToScene("crossroads", { x: 35 * 16, y: 10 * 16 });
      },
    });

    this.add(this.door);

    this.houseDoor = new ex.Trigger({
      pos: new ex.Vector(31 * 16, 6 * 16),
      width: 16,
      height: 60,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        console.log("TRIGGERED: Go TO SCENE");
        goToScene("billsHouse", { x: 20 * 16, y: 18 * 16 });
      },
    });

    this.add(this.houseDoor);
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
      this.player.lastDir = data.data.direction;
    }
  }
  onPostUpdate() {
    //     if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
    //       if (this.computerCollision) {
    //         console.log("pressed space, should go");
    //         goToScene("onlineMarket");
    //       }
    //     }
    //   }
  }
}
